import React, { useEffect } from 'react';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import SiteHeader from '@wix/da-shared-react/pkg/SiteHeader';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import DrawerLoadable from '@wix/da-feedback-shared/pkg/Drawer/DrawerLoadable';
import FeedbackPageLoadable from '@wix/da-feedback-shared/pkg/FeedbackPage/FeedbackPageLoadable';
import { composeModalRenderers } from '@wix/da-shared-react/pkg/Modals/helpers';
import { adoptsModalRenderer } from '@wix/da-adopts-shared/pkg/project-tools';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';
import { muroModalRenderer } from '@wix/da-muro-ui/pkg/project-tools';
import ForumListPage from '../ForumListPage';
import ForumPage from '../ForumPage';
import ThreadPage from '../ThreadPage';
import ForumSearchPage from '../ForumSearchPage';
import forumModalRenderer from './Modals';
import { MuroDepContext } from '@wix/da-react-context/pkg/MuroDepContext';
import MicroMuro from '@wix/da-muro-ui/pkg/components/MuroEditor/preset/Micro';
import MiniMuro from '@wix/da-muro-ui/pkg/components/MuroEditor/preset/Mini';
import MobileMuro from '@wix/da-muro-ui/pkg/components/MuroEditor/preset/Mobile';
import DamzDrawerLoadable from '@wix/da-damz-shared/pkg/components/Drawer/DrawerLoadable';
import DamzPageLoadable from '@wix/da-damz-shared/pkg/components/DamzPage/DamzPageLoadable';
import DamzGlobal from '@wix/da-damz-shared/pkg/redux/ModuleLoader';
import { damzModalRenderer } from '@wix/da-damz-shared/pkg/project-tools';

const MuroDepValue = {
  MicroComponent: MicroMuro,
  MiniComponent: MiniMuro,
  MobileComponent: MobileMuro,
};

import s from './App.scss';

const modalsRenderFunc = composeModalRenderers(
  forumModalRenderer,
  adoptsModalRenderer,
  muroModalRenderer,
  submitModalRenderer,
  damzModalRenderer as any
);

export interface Props {
  language: string;
  environment?: RuntimeEnvironment;
  pageType?: string;
  appLoaded: () => void;
}

const App: React.FC<Props> = ({ language, environment, pageType, appLoaded }) => {
  useEffect(() => {
    appLoaded();
  }, [appLoaded]);

  return (
    <MuroDepContext.Provider value={MuroDepValue}>
      <DaApp
        language={language}
        environment={environment}
        modalsRenderFunc={modalsRenderFunc}
        ncContextProps={{
          PageComponent: FeedbackPageLoadable,
          DrawerComponent: DrawerLoadable,
        }}
        damzContextProps={{
          GlobalComponent: DamzGlobal,
          DrawerComponent: DamzDrawerLoadable,
          PageComponent: DamzPageLoadable,
        }}
        bodyClassName={s['root']}
      >
        <div className={s['header']}>
          <SiteHeader />
        </div>
        {getForumPage(pageType)}
        <SiteFooter />
      </DaApp>
    </MuroDepContext.Provider>
  );
};

export default App;

function getForumPage(pageType?: string): React.ReactNode {
  switch (pageType) {
    case 'forum':
      return <ForumPage />;
    case 'forumThread':
      return <ThreadPage />;
    case 'forumSearch':
      return <ForumSearchPage />;
    case 'forumList':
    default:
      return <ForumListPage />;
  }
}
